import React from "react";
import styled from "styled-components";

const Content = props => {
  const { data, setActiveCoupon } = props;
  // 사용할 데이터 issueCpnNo

  const convertDate = () => {
    const dateItem = data.useToDh.split(" ")[0].split("-");

    return (
      dateItem[0] +
      "년 " +
      dateItem[1] +
      "월 " +
      dateItem[2] +
      "일 까지 사용 가능"
    );
  };
  return (
    <ContentBody active={props.active} onClick={() => setActiveCoupon(data)}>
      <TopText>
        <Title>{data.cpnNm}</Title>
        <Desc>{data.cpnDesc}</Desc>
      </TopText>

      {/* <BottomText>2024년 12월 31일 까지 사용 가능</BottomText> */}
      <BottomText>{convertDate()}</BottomText>
    </ContentBody>
  );
};

const ContentBody = styled.div`
  width: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  padding: 20px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px 0
    ${props =>
      props.active ? "rgba(107, 101, 222, 0.5)" : "rgba(0, 0, 0, 0.08)"};

  // rgba(0, 0, 0, 0.08)
  border: solid 1px ${props => (props.active ? "#6b65de" : "#eee")};
  background-color: #fff;
  flex-flow: column;
`;

const TopText = styled.div`
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
  padding: 0;
`;

const Title = styled.span`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  text-align: left;
  color: #6b65de;
`;

const Desc = styled.div`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.24px;
  text-align: left;
  color: #333;
`;

const BottomText = styled.span`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.24px;
  text-align: left;
  color: #888;
`;
export default Content;
